import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../../../contexts/LocaleContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useLocale();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="vopub-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>VoPub</h3>
            <p>Your reading, listening, and learning companion — all in one.</p>
          </div>
          
          <div className="footer-section">
            <h4>{t('footerLegalTitle')}</h4>
            <ul>
              <li><Link to="/vopub/privacy">{t('footerPrivacyPolicy')}</Link></li>
              <li><Link to="/vopub/terms">{t('footerTermsOfService')}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} VoPub. {t('footerAllRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;